<div class="body_container">
  <div class="listHeader">
    <h4>License Server List</h4>
    <button
        *ngIf="!isMonitor && isGlobalAdmin"
        type="button"
        title="Add new license server"
        class="default-btn"
        style="float: right"
        (click)="addLicenseServer()"
      >
        <span class="bi bi-plus-lg"></span>
        New License Server
    </button>
  </div>
  <div class="tableList" style="white-space: nowrap;">
    <table class="table ">
      <thead class="cursor-default">
        <tr class="table-list-head">
          <th resizable>#</th>
          <th resizable>
            Name
            <span style="cursor: pointer" [ngClass]="
                  sortName == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                "
                  class="bi" (click)="sortByName()"></span>
          </th>
          <th resizable>
            Type
            <span style="cursor: pointer"  [ngClass]="
                  sortType == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                "
                  class="bi" (click)="sortByType()"></span>
          </th>
          <th resizable>
            ServerAddress
            <span style="cursor: pointer" [ngClass]="
                  sortServerAddress == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                "
                  class="bi" (click)="sortByServerAddress()"></span>
          </th>
          <th resizable class="text-center" *ngIf="!isMonitor && isGlobalAdmin">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="isDataAvailable == true">
        <tr class="hpc-cursor-pointer table-list-row" *ngFor="
            let server of licenseServers | paginate: { itemsPerPage: 14, currentPage: activePage };
            let i = index
          ">
          <td scope="row" *ngIf="p == 1">{{ i + 1 }}</td>
          <td scope="row" *ngIf="p != 1">
            {{ (p - 1) * 10 + (i + 1) }}
          </td>
          <td [title]="server.licenseName" class="cursor-pointer impListName" (click)="redirectToLicenseInfo(server.licenseName, i)">{{ server.licenseName }}</td>
          <td (click)="redirectToLicenseInfo(server.licenseName, i)">{{ server.licenseType }}</td>
          <td (click)="redirectToLicenseInfo(server.licenseName, i)">{{ server.licenseServerAddress }}</td>
          <td class="text-center" *ngIf="!isMonitor && isGlobalAdmin">
            <button type="button" class="actionBtn" (click)="updateLicenseServer(server)" triggers="hover" ngbTooltip="update"> <span class="bi bi-pencil-square"></span></button>
            <button type="button" class="actionBtn" (click)="deleteLicenseServer(server.licenseName)" triggers="hover" ngbTooltip="delete"> <span class="bi bi-trash3"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination-controls *ngIf="licenseServers"
                         class="my-pagination"
                         (pageChange)="p = $event">
    </pagination-controls>
    <p class="hpc-error-message-list" *ngIf="isDataAvailable == false">License servers not found.</p>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    name="licenseServerList"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    ><p class="pleaseWait">Please wait ...</p></ngx-spinner
  >
</div>
